import { css } from 'styled-components';
import { PositionMap } from './SimpleForm';
import {
	Field,
	FieldArrayString,
	FieldButtonSelect,
	FieldCheckBox,
	FieldSelect,
	OnFinishReturnObject,
	RepeatableField,
} from './SimpleFormTypes';

export const isFinishElement = (element: any = {}): element is OnFinishReturnObject => element.status && element.title;

export const isFieldSelect = (field: Field): field is FieldSelect => field.type === 'select';
export const isFieldCheckBox = (field: Field): field is FieldCheckBox => field.type === 'checkbox';
export const isFieldButtonSelect = (field: Field): field is FieldButtonSelect => field.type === 'button-select';
export const isFieldArrayString = (field: Field): field is FieldArrayString => field.type === 'array-string';
export const isFieldRepeatable = (field: Field): field is RepeatableField => field.type === 'repeatable';

export const canShowField = (field: Field, values: any) => {
	if (field.showWhen) {
		return Object.entries(field.showWhen).every(([key, value]) => {
			if (typeof value === 'function') {
				return value(values[key]);
			}
			if (Array.isArray(value)) {
				return value.includes(values[key]);
			}
			return values[key] === value;
		});
	}
	return true;
};

export const hasShowWhen = (fields: Field[], keys: string[]) =>
	fields.some(field => {
		if (field.showWhen) {
			return keys.some(key => key in field.showWhen!);
		}
		return false;
	});

export const sortFields = (fields: Field[], positionMap: PositionMap) =>
	fields.sort((a, b) => {
		const aIndex = (field: Field) => {
			if (field.key in positionMap) {
				return positionMap[field.key].row + positionMap[field.key].rowIndex;
			}
			return Number.MAX_SAFE_INTEGER;
		};
		return aIndex(a) - aIndex(b);
	});

const generateGridTemplateAreas = (gridPositions: string[][], addFooter?: boolean) => {
	const gridTemplateAreas = gridPositions.map(row => `"${row.join(' ')}"`).join('\n');

	if (addFooter) {
		const footer = new Array(gridPositions[0]?.length ?? 0).fill('footer').join(' ');
		return `${gridTemplateAreas}\n"${footer}"`;
	}

	return gridTemplateAreas;
};

export const generateCustomGridAreasCss = (gridPositions: string[][], addFooter?: boolean) => {
	const gridTemplateAreas = generateGridTemplateAreas(gridPositions, addFooter);

	return css`
		grid-template-areas: ${gridTemplateAreas};
	`;
};

export const getVisibleGridPositions = (fields: Field[], formValues: any, gridPositions?: string[][]) =>
	gridPositions?.filter(row =>
		row.some(field => {
			const currentField = fields.filter(f => f.key.split('#')[0] === field);

			if (currentField.length === 0) {
				return true;
			}

			return currentField.some(f => canShowField(f, formValues));
		}),
	);
